import { render, staticRenderFns } from "./form-label.vue?vue&type=template&id=6e69eb68&scoped=true&"
import script from "./form-label.vue?vue&type=script&lang=js&"
export * from "./form-label.vue?vue&type=script&lang=js&"
import style0 from "./form-label.vue?vue&type=style&index=0&id=6e69eb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e69eb68",
  null
  
)

export default component.exports